

import { html, LitElement, } from 'lit-element';

export class IconArrowDown extends LitElement {
  static get properties() {
    return {
      active: { type: Boolean, reflect: true, },
      width: { type: Number, reflect: true, },
      height: { type: Number, reflect: true, },
    };
  }

  constructor() {
    super();
    this.width = 20;
    this.height = 20;
  }
  
  render() {
    return html`    
    <svg width="${this.width}" height="${this.height}" fill="currentColor"  version="1.1" id="레이어_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 132 132" style="enable-background:new 0 0 132 132;" xml:space="preserve"><style type="text/css">.st0{fill:#626262;}</style><g id="Path_1357"><polygon class="st0" points="54.5,108.6 54.5,23.4 57.8,23.4 57.8,100.5 75.2,83.2 77.6,85.5 "/></g></svg>
    `;
  }
}

customElements.define('icon-arrow-down', IconArrowDown);